import config from '../../config/index.js';

function isElementCollectionValid(elements) {
  return elements.every((el) => el !== null);
}

export function showProfileSetupWizardAndWait(token) {
  return new Promise((resolve) => {
    const modal = document.getElementById('profile-setup-modal');
    const step0 = document.getElementById('profile-setup-step0');
    const step0NextBtn = document.getElementById('step0-next-btn');
    const step1 = document.getElementById('profile-setup-step1');
    const step1NextBtn = document.getElementById('step1-next-btn');
    const step1SkipBtn = document.getElementById('step1-skip-btn');
    const placeholderIcon = document.getElementById('profile-setup-placeholder-icon');
    const previewWrapper = document.getElementById('profile-setup-preview-wrapper');
    const previewImg = document.getElementById('profile-setup-preview');
    const uploadInstructions = document.getElementById('profile-upload-instructions');
    const fileInput = document.getElementById('profile-setup-file-input');
    const picError = document.getElementById('profile-setup-pic-error');
    const cropperWrapper = document.getElementById('profile-setup-cropper-wrapper');
    const cropperImage = document.getElementById('profile-setup-cropper-image');
    const cropBtn = document.getElementById('profile-setup-crop-btn');
    const step2 = document.getElementById('profile-setup-step2');
    const step2BackBtn = document.getElementById('step2-back-btn');
    const step2SaveBtn = document.getElementById('step2-save-btn');
    const usernameInput = document.getElementById('profile-setup-username');
    const usernameError = document.getElementById('profile-setup-username-error');

    const requiredElements = [
      modal,
      step1,
      step1NextBtn,
      step1SkipBtn,
      placeholderIcon,
      previewWrapper,
      previewImg,
      uploadInstructions,
      fileInput,
      picError,
      cropperWrapper,
      cropperImage,
      cropBtn,
      step2,
      step2BackBtn,
      step2SaveBtn,
      usernameInput,
      usernameError,
    ];

    if (!isElementCollectionValid(requiredElements)) {
      resolve({ cancelled: true, reason: 'missing-elements' });
      return;
    }

    let resolved = false;
    let cropper = null;
    let croppedBlob = null;
    let currentImageData = null;
    let fileObjectURL = null;
    let previewObjectURL = null;

    const revoke = (url) => {
      if (!url) return;
      try {
        URL.revokeObjectURL(url);
      } catch (error) {
        // Silently ignore revoke errors to keep UX smooth
      }
    };

    const closeModal = (result) => {
      if (resolved) return;
      resolved = true;

      modal.style.display = 'none';

      if (step0) step0.style.display = 'block';
      step1.style.display = 'none';
      step2.style.display = 'none';

      fileInput.value = '';
      previewImg.style.display = 'none';
      placeholderIcon.style.display = 'inline-block';
      previewWrapper.style.display = 'flex';
      uploadInstructions.style.display = 'block';
      cropperWrapper.style.display = 'none';
      cropBtn.style.display = 'none';
      picError.style.display = 'none';
      usernameInput.value = '';
      usernameError.style.display = 'none';

      step1NextBtn.disabled = true;
      step1NextBtn.innerText = 'Continue';
      step1NextBtn.style.display = 'inline-block';

      if (cropper) {
        cropper.destroy();
        cropper = null;
      }

      revoke(fileObjectURL);
      revoke(previewObjectURL);
      fileObjectURL = null;
      previewObjectURL = null;
      croppedBlob = null;
      currentImageData = null;

      placeholderIcon.removeEventListener('click', handlePlaceholderClick);
      previewWrapper.removeEventListener('click', handlePreviewWrapperOpen);
      previewWrapper.removeEventListener('click', handlePreviewWrapperAdvance);
      previewImg.removeEventListener('click', handlePreviewImgClick);
      fileInput.removeEventListener('change', handleFileChange);
      cropBtn.removeEventListener('click', handleCropClick);
      step1NextBtn.removeEventListener('click', handleStep1Next);
      step1SkipBtn.removeEventListener('click', handleStep1Skip);
      step2BackBtn.removeEventListener('click', handleStep2Back);
      step2SaveBtn.removeEventListener('click', handleStep2Save);
      if (step0NextBtn) {
        step0NextBtn.removeEventListener('click', handleStep0Next);
      }

      resolve(result);
    };

    const openFileSelector = () => {
      fileInput.value = '';
      fileInput.click();
    };

    const handlePlaceholderClick = (event) => {
      event.stopPropagation();
      openFileSelector();
    };

    const handlePreviewWrapperOpen = () => {
      openFileSelector();
    };

    const handlePreviewWrapperAdvance = () => {
      goToStep2();
    };

    const handlePreviewImgClick = (event) => {
      event.stopPropagation();
      if (currentImageData) {
        openCropper(currentImageData);
      } else {
        openFileSelector();
      }
    };

    const handleStep0Next = () => {
      if (step0) {
        step0.style.display = 'none';
      }
      step1.style.display = 'block';
    };

    const goToStep2 = () => {
      picError.style.display = 'none';
      step1.style.display = 'none';
      step2.style.display = 'block';
    };

    const handleStep1Next = () => {
      goToStep2();
    };

    const handleStep1Skip = () => {
      goToStep2();
    };

    const handleStep2Back = () => {
      step2.style.display = 'none';
      step1.style.display = 'block';
    };

    const handleFileChange = () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) return;

      if (!file.type || !file.type.startsWith('image/')) {
        alert('Please choose a valid image file.');
        return;
      }

      revoke(fileObjectURL);
      fileObjectURL = URL.createObjectURL(file);
      currentImageData = fileObjectURL;
      openCropper(fileObjectURL);
    };

    const handleCropClick = () => {
      if (!cropper) return;

      const canvas = cropper.getCroppedCanvas({ width: 300, height: 300 });
      canvas.toBlob((blob) => {
        if (!blob) {
          alert('Cropping failed. Try another image.');
          return;
        }

        croppedBlob = blob;
        revoke(previewObjectURL);
        previewObjectURL = URL.createObjectURL(blob);

        previewImg.src = previewObjectURL;
        previewImg.style.display = 'inline-block';
        placeholderIcon.style.display = 'none';

        cropperWrapper.style.display = 'none';
        cropBtn.style.display = 'none';
        previewWrapper.style.display = 'flex';
        uploadInstructions.style.display = 'block';

        step1NextBtn.style.display = 'inline-block';
        step1NextBtn.disabled = false;
        step1NextBtn.innerText = 'Continue';

        previewWrapper.removeEventListener('click', handlePreviewWrapperOpen);
        previewWrapper.addEventListener('click', handlePreviewWrapperAdvance);
      }, 'image/png');
    };

    const handleStep2Save = async () => {
      const desiredUsername = usernameInput.value.trim();
      const usernameRegex = /^[a-zA-Z0-9_]{3,15}$/;

      if (!usernameRegex.test(desiredUsername)) {
        usernameError.innerText =
          'Username must be 3-15 characters and contain only letters, numbers, and underscores.';
        usernameError.style.display = 'block';
        return;
      }

      usernameError.style.display = 'none';

      try {
        const res = await fetch(`${config.detectionUrl}/set-username`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ username: desiredUsername }),
        });
        const data = await res.json();
        if (!res.ok || !data.username) {
          usernameError.innerText = data.error || 'Failed to set username.';
          usernameError.style.display = 'block';
          return;
        }
      } catch (error) {
        console.error('Error setting username:', error);
        usernameError.innerText = 'An error occurred. Please try again.';
        usernameError.style.display = 'block';
        return;
      }

      if (croppedBlob) {
        try {
          const formData = new FormData();
          formData.append('profile-picture', croppedBlob, 'cropped.png');

          const picRes = await fetch(`${config.detectionUrl}/save-profile-pic`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
          });

          if (!picRes.ok) {
            const errData = await picRes.json();
            picError.innerText = errData.error || 'Failed to set profile picture.';
            picError.style.display = 'block';
            return;
          }
        } catch (error) {
          console.error('Error uploading pic:', error);
          picError.innerText = 'An error occurred. Please try again.';
          picError.style.display = 'block';
          return;
        }
      }

      closeModal({ cancelled: false, startFirstScan: true });
    };

    const openCropper = (src) => {
      previewWrapper.style.display = 'none';
      uploadInstructions.style.display = 'none';
      cropperWrapper.style.display = 'block';
      cropBtn.style.display = 'inline-block';
      step1NextBtn.style.display = 'none';
      step1NextBtn.disabled = true;

      if (typeof cropperWrapper.scrollIntoView === 'function') {
        const scheduleScroll =
          typeof window.requestAnimationFrame === 'function'
            ? window.requestAnimationFrame.bind(window)
            : (callback) => window.setTimeout(callback, 0);
        scheduleScroll(() => {
          cropperWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      previewWrapper.removeEventListener('click', handlePreviewWrapperAdvance);
      previewWrapper.removeEventListener('click', handlePreviewWrapperOpen);

      cropperImage.src = src;

      if (cropper) {
        cropper.destroy();
      }

      if (typeof window.Cropper === 'undefined') {
        picError.innerText = 'Image cropping is unavailable. Please refresh and try again.';
        picError.style.display = 'block';
        cropperWrapper.style.display = 'none';
        cropBtn.style.display = 'none';
        previewWrapper.style.display = 'flex';
        uploadInstructions.style.display = 'block';
        return;
      }

      cropperImage.onload = () => {
        cropper = new window.Cropper(cropperImage, {
          aspectRatio: 1,
          viewMode: 1,
          background: false,
          minContainerHeight: 300,
          minContainerWidth: 300,
          guides: false,
          center: false,
        });
      };
    };

    modal.style.display = 'flex';

    if (step0 && step0NextBtn) {
      step0.style.display = 'block';
      step1.style.display = 'none';
      step0NextBtn.addEventListener('click', handleStep0Next);
    } else {
      step1.style.display = 'block';
    }

    step2.style.display = 'none';

    step1NextBtn.disabled = true;
    step1NextBtn.innerText = 'Continue';
    step1NextBtn.style.display = 'inline-block';

    previewWrapper.style.display = 'flex';
    previewImg.style.display = 'none';
    placeholderIcon.style.display = 'inline-block';
    uploadInstructions.style.display = 'block';
    cropperWrapper.style.display = 'none';
    cropBtn.style.display = 'none';
    picError.style.display = 'none';
    usernameError.style.display = 'none';

    placeholderIcon.addEventListener('click', handlePlaceholderClick);
    previewWrapper.addEventListener('click', handlePreviewWrapperOpen);
    previewImg.addEventListener('click', handlePreviewImgClick);
    fileInput.addEventListener('change', handleFileChange);
    cropBtn.addEventListener('click', handleCropClick);
    step1NextBtn.addEventListener('click', handleStep1Next);
    step1SkipBtn.addEventListener('click', handleStep1Skip);
    step2BackBtn.addEventListener('click', handleStep2Back);
    step2SaveBtn.addEventListener('click', handleStep2Save);
  });
}
